




















import { Component, Vue } from "vue-property-decorator";
import IconPillButton from "@/shared/components/iconPillButton/iconPillButton.vue";
import IconUsers from "@/shared/components/icons/IconUsers.vue";
import MenuShopCart from "@/shared/components/menuShopCart/menuShopCart.vue";
import AccountMenu from "@/shared/components/accountMenu/accountMenu.vue";
import store from "@/shared/core/store";

@Component({
  components: { IconPillButton, IconUsers, MenuShopCart, AccountMenu },
})
export default class EmbeddedActions extends Vue {
  userMenuOpen: boolean = false;

  get isLoggedIn() {
    return store.state.loggedIn === true;
  }

  toggleUserMenu() {
    this.userMenuOpen = !this.userMenuOpen;
  }

  closeUserMenu() {
    this.userMenuOpen = false;
  }
}
